import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DeviceType } from '@horasys/bellplus/common/types';
import { SET_PROGRESS } from './progressSlice';
import { getDeviceTypes } from 'services/devices.service';
import { SEND_MESSAGE } from './errorHandlingSlice';

const deviceType: DeviceType = {} as DeviceType;
export interface DeviceTypeState {
	list: Array<any>;
	deviceType: DeviceType;
}
const initialState: DeviceTypeState = {
	list: [],
	deviceType: deviceType,
};
const DeviceTypeSlice = createSlice({
  name:'deviceType',
  initialState,
  reducers:{
    GET_DEVICE_TYPES_SUCCESS:(state, action:PayloadAction<any>):DeviceTypeState=>{
        return {
            ...state,
            list: action.payload,
        };
    }
  }
})

export const { GET_DEVICE_TYPES_SUCCESS} = DeviceTypeSlice.actions
export default DeviceTypeSlice.reducer

export const deviceTypesList = ():any => async (dispatch: any) => {
	try {
		dispatch(SET_PROGRESS(true));
		const deviceType = await getDeviceTypes();
		dispatch(GET_DEVICE_TYPES_SUCCESS(deviceType));
		dispatch(SET_PROGRESS(false));
	} catch (error:any) {
		dispatch(SEND_MESSAGE({messange:error, type:'error'}));
		dispatch(SET_PROGRESS(false));
	}
};
